import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import type {UiCondition} from '../../../modules/ruleengine/types';
import formatTimestamp from '../../common/formatTimestamp';
import TriggerResetButton from './TriggerResetButton';
type Props = {
	condition: UiCondition;
	onReset: (id: string) => void;
};
const RESET_BY_SYSTEM_STRING = 'rafi.system.user';
const placeholder = <Trans i18nKey="ruleengine.triggerDetails.notApplicable">N/A</Trans>;

const renderLastResetAtOrPlaceholder = (lastResetAt?: string) => {
	if (lastResetAt) {
		return formatTimestamp(lastResetAt);
	}

	return placeholder;
};

const renderLastResetByOrPlaceholder = (lastResetBy?: string) => {
	if (lastResetBy) {
		return lastResetBy === RESET_BY_SYSTEM_STRING ? (
			<Trans i18nKey={RESET_BY_SYSTEM_STRING}>{RESET_BY_SYSTEM_STRING}</Trans>
		) : (
			<a href={`mailto:${lastResetBy}`}>{lastResetBy}</a>
		);
	}

	return placeholder;
};

const TriggerCountDetails = ({condition, onReset}: Props) => {
	const {counter, id} = condition;

	const handleReset = () => {
		if (id) {
			onReset(id);
		}
	};

	if (!counter) {
		return null;
	}

	return (
		<div className="trigger-count-details">
			<div>
				<div className="trigger-detail-row">
					<label>
						<Trans i18nKey="ruleengine.triggerDetails.triggerValue">Trigger Value:</Trans>
					</label>
					<div data-testid="trigger-details-trigger-value">{counter.conditionCount}</div>
				</div>
				<div className="trigger-detail-row">
					<label>
						<Trans i18nKey="ruleengine.triggerDetails.currentCount">Current Count:</Trans>
					</label>
					<div data-testid="trigger-details-trigger-current">{counter.currentCount}</div>
				</div>
				<div className="trigger-detail-row">
					<label>
						<Trans i18nKey="ruleengine.triggerDetails.lastResetAt">Last reset at:</Trans>
					</label>
					<div data-testid="trigger-details-trigger-reset-date">
						{renderLastResetAtOrPlaceholder(counter.lastResetAt)}
					</div>
				</div>
				<div className="trigger-detail-row">
					<label>
						<Trans i18nKey="ruleengine.triggerDetails.lastResetBy">Last reset by:</Trans>
					</label>
					<div data-testid="trigger-details-trigger-reset-by">
						{renderLastResetByOrPlaceholder(counter.lastResetBy)}
					</div>
				</div>
			</div>
			{!!counter.currentCount && <TriggerResetButton onReset={handleReset} />}
		</div>
	);
};

export default TriggerCountDetails;
